import script from "./PaymentHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentHistory.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentHistory.vue?vue&type=style&index=0&id=03de0afd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03de0afd"]])

export default __exports__